// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1TSwk","title":"Images45_title__fSYP5","images":"Images45_images__ElRIs"};